import React, { useState } from "react";
import { useEffect } from "react";
import {
  Bar,
  XAxis,
  YAxis,
  BarChart,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import faker from "faker";

import { Loading } from "../../webtracking/components";
import { DateRange } from "../components";

const useAverageLeadTime = () => {
  const [range, setRange] = useState(null);
  const [groups, setGroups] = useState([]);
  const [isLoading, setLoading] = useState(true);

  const loadGroups = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      let groups = [];
      for (let i = 0; i < 30; i++) {
        groups.push({
          name: faker.company.companyName(),
          days: (Math.random() * 100).toFixed(2),
        });
      }
      groups.sort((a, b) => b.days - a.days);
      setGroups(groups);
    }, 500);
  };

  useEffect(() => {
    loadGroups();
  }, [range]);

  return { range, setRange, groups, isLoading };
};

const CustomTooltip = ({ active, label, payload }) => {
  if (active) {
    return (
      <div style={{ padding: "1rem", background: "rgba(255,255,255,0.5)" }}>
        <p>{label}</p>
        <p>Días promedio: {payload[0].value}</p>
      </div>
    );
  }

  return null;
};

const AverageLeadTime = () => {
  const { range, setRange, groups, isLoading } = useAverageLeadTime();

  return (
    <div className="container has-background-light p-6 mt-5">
      <DateRange range={range} setRange={setRange} />
      <div className="card">
        <div className="card-content">
          {isLoading ? (
            <Loading />
          ) : (
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={groups}>
                <XAxis dataKey="name" type="category" />
                <YAxis type="number" />
                <Tooltip content={<CustomTooltip />} />
                <Bar dataKey="days" fill="#30d2d6"></Bar>
              </BarChart>
            </ResponsiveContainer>
          )}
        </div>
      </div>
    </div>
  );
};

export default AverageLeadTime;
